import { FC } from "react";

import { Stack } from "@mui/material";

import { GenericErrorDisclaimer } from "@/components/GenericError/GenericErrorDisclaimer";
import { DashboardIconButton } from "@/dashboard-design-system/DashboardButton";
import { Cross } from "@/icons/outlined";

type ErrorTabProps = {
  onClose?: () => void;
};

export const ErrorTab: FC<ErrorTabProps> = ({ onClose }) => {
  return (
    <Stack alignItems="center" gap={2} padding={(theme) => theme.spacing(3, 3, 5, 3)}>
      <DashboardIconButton onClick={onClose} sx={{ alignSelf: "flex-end" }}>
        <Cross />
      </DashboardIconButton>
      <GenericErrorDisclaimer />
    </Stack>
  );
};
